import React from 'react';
import { InstagramIcon, MailIcon, GlobeIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/contact';
const links = [{
  icon: MailIcon,
  label: SUPPORT_EMAIL,
  href: `mailto:${SUPPORT_EMAIL}`
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  href: '#offer'
}, {
  icon: GlobeIcon,
  label: 'Official website',
  href: '#offer'
}];
export function SiteFooter() {
  return <footer className="bg-noir py-12 sm:py-14" data-id="element-223" data-mp="3dgl3lbw88h2m">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-224" data-mp="3difq2un5ch8t">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-225" data-mp="38h8hitd6je13">
          <div className="max-w-md" data-id="element-226" data-mp="33if0ws2lj6wp">
            <p className="font-display text-xl leading-snug text-gold-light sm:text-2xl" data-id="element-227" data-mp="33jgfh6itmbj6">
              Jazz Teacher&rsquo;s Arsenal&trade;
            </p>
            <p className="mt-2 text-sm text-paper-400" data-id="element-228" data-mp="11r1z4bvxdf4v">
              The complete system for professional jazz educators.
            </p>
            <p className="mt-5 font-display text-base italic leading-snug text-gold-dark sm:text-lg" data-id="element-229" data-mp="wtil9d3534dg">
              Because teaching jazz shouldn&rsquo;t cost you every evening of the week.
            </p>
          </div>

          <nav aria-label="Footer" className="flex flex-col gap-3" data-id="element-230" data-mp="1ar9k4t21udii">
            {links.map(({
            icon: Icon,
            label,
            href
          }) => <a key={label} href={href} className="flex items-center gap-3 text-sm text-paper-300 transition-colors duration-150 ease-out hover:text-gold" data-id="element-231" data-mp="10rsg0g2g47on">
                <Icon className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-232" data-mp="1tgzb152oyf55" />
                {label}
              </a>)}
          </nav>
        </div>

        <p className="mt-10 border-t border-wood-dark pt-6 text-[10px] uppercase tracking-label text-paper-400 sm:text-[11px]" data-id="element-233" data-mp="1epgwzcte6uof">
          &copy; Jazz Teacher&rsquo;s Arsenal&trade; 2026 &mdash; All rights reserved.
        </p>
      </div>
    </footer>;
}